import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface AdminPageProps extends HTMLAttributes<HTMLDivElement> {
  /** full (default) spans the content area; narrow centres settings/forms at ~1080px. */
  width?: 'full' | 'narrow';
}

/** Standard admin page wrapper: responsive padding and vertical rhythm. */
export function AdminPage({ width = 'full', className, ...rest }: AdminPageProps) {
  return (
    <div
      className={cn(
        'space-y-5 p-4 md:p-6 lg:p-8',
        width === 'narrow' && 'w-full max-w-[1080px] 2xl:mx-auto',
        className,
      )}
      {...rest}
    />
  );
}
